// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.direct-upload-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  color: #555;
  margin-bottom: 8px;
}

.direct-upload-error {
  color: #c62828;
  font-size: 0.85rem;
  margin-bottom: 8px;
}

.attachment-host {
  width: 100%;
}

mat-dialog-content {
  min-width: 600px;
  min-height: 200px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

.content {
  padding: 16px;
  border-radius: 4px;
}


.attachment-section-title {
  font-size: 18px;
  font-weight: 600;
  color: #0b2d71;
}


.button-gap {
  gap: 12px;
}

.wa-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.wa-dialog {
  min-width: 600px;
  max-width: 94vw;
  background: #f0f0f0;
  border-radius: 4px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.wa-dialog [mat-dialog-title] {
  background-color: #f0f0f0;
  margin: 0 !important;
  padding: 4px 12px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}



.wa-dialog mat-dialog-content .content {
  background-color: #f0f0f0;
  box-shadow: none;
}

.wa-dialog mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 4px 12px !important;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}


.row-item {
  border: 1px solid #d3d3d3;
  padding: 12px;
  border-radius: 4px;
  background-color: #fff;
}

.field-label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
}

.form-control {
  width: 100%;
  margin-bottom: 10px;
}

.hidden-file-input {
  display: none;
}

.field-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.field-value {
  flex: 1;
}

.field-error {
  color: #dc3545;
  font-size: 0.75rem;
  margin-top: 2px;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/attachment-component/attachment-component.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;;;AAIA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;;AAGA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}\n\n.direct-upload-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.85rem;\n  color: #555;\n  margin-bottom: 8px;\n}\n\n.direct-upload-error {\n  color: #c62828;\n  font-size: 0.85rem;\n  margin-bottom: 8px;\n}\n\n.attachment-host {\n  width: 100%;\n}\n\nmat-dialog-content {\n  min-width: 600px;\n  min-height: 200px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\n\n.attachment-section-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #0b2d71;\n}\n\n\n.button-gap {\n  gap: 12px;\n}\n\n.wa-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1050;\n}\n\n.wa-dialog {\n  min-width: 600px;\n  max-width: 94vw;\n  background: #f0f0f0;\n  border-radius: 4px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n}\n\n.wa-dialog [mat-dialog-title] {\n  background-color: #f0f0f0;\n  margin: 0 !important;\n  padding: 4px 12px !important;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\n\n\n\n.wa-dialog mat-dialog-content .content {\n  background-color: #f0f0f0;\n  box-shadow: none;\n}\n\n.wa-dialog mat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 4px 12px !important;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n\n.row-item {\n  border: 1px solid #d3d3d3;\n  padding: 12px;\n  border-radius: 4px;\n  background-color: #fff;\n}\n\n.field-label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 600;\n}\n\n.form-control {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.hidden-file-input {\n  display: none;\n}\n\n.field-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.field-value {\n  flex: 1;\n}\n\n.field-error {\n  color: #dc3545;\n  font-size: 0.75rem;\n  margin-top: 2px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
